export class ActivePregnantVaccination {
	id: number = 0;
	citizenExtraId: number = 0;
	fullName?: string;
	gender?: string;
	phone?: string;
	identifier?: string;
	cns?: string;
	birthdate?: string;
	houseNumber?: string;
	neighborhood?: string;
	city?: string;
	uf?: string;
	street?: string;
	cep?: string;
	countRegisters: number = 0;
}
